
import axios from 'axios'; // 引入axios
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8;';


/**
  * get方法，对应get请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function get(url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      headers: headers
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      })
  })
}
/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function post(url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, { headers: headers })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      })
  })
}


/**
  * put方法，对应put请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function put(url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.put(url, params, {
      headers: headers
    })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (err) {
        reject(err)
      });
  })
}

export function delet (url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params,
      headers: headers
    })
      .then(res => {
        resolve(res)
      })
      .catch(err =>{
        reject(err)
      });
  })
}



